import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ActionService } from '@kaiser-software/chassis-datatable';
import { ChassisEntityCollectionServiceBase } from '@kaiser-software/chassis-resource/src/services/chassis-entity-collection-service-base';
import { IAbstractEntity } from '@kaiser-software/chassis-resource/src/interfaces';
import { ResourceService } from '@kaiser-software/chassis-resource';

import { button, BUTTONS } from '../../../support/buttons';
import { RouteService } from '../../../routing/services/route.service';
import { ToolbarService } from '../../../layouts/toolbar/services/toolbar.service';
import { ShowComponent } from '../../components/actions/show/show.component';
import { DeleteComponent } from '../../components/actions/delete/delete.component';
import { EditComponent } from '../../components/actions/edit/edit.component';

@Component({
    selector: 'index-page',
    templateUrl: 'index.page.html'
})

export class IndexPage implements OnInit {

    public entityName: string;

    protected entityService: ChassisEntityCollectionServiceBase<IAbstractEntity>;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected resourceService: ResourceService,
        protected routeService: RouteService,
        protected toolbarService: ToolbarService,
        protected actionService: ActionService
    ) {

        this.resourceService
            .getResourceFromUrl(this.routeService.currentUrl)
            .subscribe(service => {
                this.entityService = service;
                this.entityName    = service.entityName;

                this.init();
            });

    }

    ngOnInit() {
    }

    protected init() {
        this.registerToolbarButtons();
        this.registerActions();
    }

    protected registerToolbarButtons() {
        this.toolbarService.add(button(BUTTONS.ADD, {
            callback: () => {
                this.createNewEntity()
            },
            authorized: () => {
                return this.entityService.authorizedTo('create');
            }
        }));
    }

    protected registerActions() {
        // TODO add authorization
        this.actionService
            .register('show', ShowComponent, {
                baseRouteName: this.entityName
            })
            .register('edit', EditComponent, {
                baseRouteName: this.entityName
            })
            .register('delete', DeleteComponent, {
                baseRouteName: this.entityName
            });
    }

    protected createNewEntity() {
        this.routeService.navigate(this.entityName + '.create');
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/pages/index/index.page.ts